import { Component, OnInit } from '@angular/core';
import { ApiCall } from '@shared/async-services/http/api-call.service';
import { BroadCastServiceService } from '@shared/services/broad-cast-service.service';
import storageService from '@shared/storage/storageService';

@Component({
  selector: 'app-superadmin-page',
  templateUrl: './superadmin-page.component.html',
  styleUrls: ['./superadmin-page.component.scss']
})
export class SuperadminPageComponent implements OnInit {

  constructor(private broadCast: BroadCastServiceService,
    private auth: ApiCall,) {

  }

  ngOnInit(): void {
    this.getCurrentUserLoginDetails();
  }

  getCurrentUserLoginDetails() {
    this.auth.getCurrentUser().subscribe(
      (res: any) => {
        storageService.setItem("currentUser",res);
      }
    )
  }
}


